import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { LoginPageRoutingModule } from './login-routing.module';

import { LoginPage } from './login.page';
import { SharedModule } from '../shared/shared.module';

// import { GoogleLoginComponent } from '../components/google-login/google-login.component';
// import { MicrosoftLoginComponent } from '../components/microsoft-login/microsoft-login.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    ReactiveFormsModule,
    LoginPageRoutingModule
  ],
  declarations: [LoginPage, 
    // GoogleLoginComponent, MicrosoftLoginComponent
  ],
  entryComponents: [
    // GoogleLoginComponent, MicrosoftLoginComponent
  ]

})
export class LoginPageModule {}
